import { Component } from '@angular/core';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-contract-action-labels',
    standalone: true,
    imports: [NgbTooltip, TranslatePipe],
    template: `
        <div class="labels-row">
            <span class="action-label" [ngbTooltip]="'contracts.tooltips.goToProfile' | translate" placement="top" container="body">{{ 'contracts.tooltips.profileLabel' | translate }}</span>
            <span class="action-label" [ngbTooltip]="'contracts.tooltips.goToStakeholders' | translate" placement="top" container="body">{{ 'contracts.tooltips.stakeholdersLabel' | translate }}</span>
            <span class="action-label" [ngbTooltip]="'contracts.tooltips.goToTask' | translate" placement="top" container="body">{{ 'contracts.tooltips.taskLabel' | translate }}</span>
            <span class="action-label" [ngbTooltip]="'contracts.tooltips.showContract' | translate" placement="top" container="body">{{ 'contracts.tooltips.contractLabel' | translate }}</span>
        </div>
    `,
    styles: [`
        .labels-row {
            display: flex;
            gap: 4px;
            align-items: center;
            height: 100%;
        }
        .action-label {
            width: 32px;
            font-size: 9px;
            line-height: 1.2;
            text-align: center;
            color: #6c757d;
            word-break: break-word;
        }
    `]
})
export class ContractActionLabelsComponent implements IFloatingFilterAngularComp {
    agInit(_params: IFloatingFilterParams): void {}
    onParentModelChanged(): void {}
}
